module.exports = __webpack_public_path__ + "img/huoke_title_bg3.0a75ad3a.png";